import { UUID_SESSION_STORAGE_KEY } from '~/contexts/Auth/AuthSession/constants';

export const getUserUuid = () => {
  const uuid = sessionStorage.getItem(UUID_SESSION_STORAGE_KEY);

  if (uuid) {
    return uuid;
  }

  const uuidMetaTag: HTMLElement = document.getElementsByName('uuid')[0];

  if (!uuidMetaTag) {
    return null;
  }

  return uuidMetaTag.attributes.getNamedItem('content').value;
};
